import { render, staticRenderFns } from "./CompetenceDialog.vue?vue&type=template&id=876297c6"
import script from "./CompetenceDialog.vue?vue&type=script&lang=ts"
export * from "./CompetenceDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports